import Cookies from 'js-cookie';
import { CQ_EDITOR_LAYER_COOKIE, CqEditorLayer } from '../constants';
import { useWindowSize } from './useWindowSize';
export const useIsShowCustomPlaceholder = () => {
    const cqEditorLayerCookie = Cookies.get(CQ_EDITOR_LAYER_COOKIE) ?? '';
    useWindowSize();
    return [CqEditorLayer.EDIT, CqEditorLayer.LAYOUTING].includes(cqEditorLayerCookie);
};
